import i18n from '../../../i18n';

const getDefaultState = () => ({
  xmlJobsOverview: {
    loading: false,
    error: false,
    noContent: false,
    items: {},
  },
  xmlChannels: {
    loading: false,
    error: false,
    noContent: false,
    items: [],
    systems: [],
  },
  filter: {
    search: undefined,
    system: undefined,
    status: [],
    statusOptions: [
      { value: 'SUCCESS', label: i18n.t('badges.success') },
      { value: 'WARNING', label: i18n.t('badges.warning') },
      { value: 'ERROR', label: i18n.t('badges.error') },
      { value: 'SYNC_ERROR', label: i18n.t('badges.sync_error') },
      { value: 'SYNCHRONIZING', label: i18n.t('badges.sync') },
      { value: 'AWAITING_SYNCHRONIZATION', label: i18n.t('badges.awaiting_sync') },
      { value: 'IMPORTING', label: i18n.t('badges.importing') },
      { value: 'NO_CONTENT', label: i18n.t('badges.no_content') },
    ],
  },
  xmlJobList: {
    xmlChannel: undefined,
    items: [],
    loading: false,
    error: false,
  },
});

export default getDefaultState;



// WEBPACK FOOTER //
// ./src/store/modules/xmlChannelStatus/defaultState.js